<div class="switch-container form-control" [ngClass]="disabled ? ['disabled'] : []">
  <span *ngIf="showLabels" class="switch-label" [ngClass]="{ active: highlightActiveLabel && !isChecked }">{{
    'Désactivé' | translate
  }}</span>
  <div class="switch" (click)="onClick($event)">
    <input
      type="checkbox"
      [checked]="isChecked ?? defaultValue"
      (change)="onChanged($event)"
      (blur)="onBlur($event)"
      [disabled]="disabled"
    />
    <span class="slider"></span>
  </div>
  <span *ngIf="showLabels" class="switch-label" [ngClass]="{ active: highlightActiveLabel && isChecked }">{{
    'Activé' | translate
  }}</span>
</div>
